const calculate = (data) => {
  if (data.PLACE === "INNER_CITY") {
    if (data.TYPE_OF_VEHICLE === "VEHICLE_ONLY") {
      switch (data.TEMPO) {
        case "LESS_THAN_10":
          return {
            fineAmount: 30,
          };
        case "11_TO_15":
          return {
            fineAmount: 50,
          };
        case "16_TO_20":
          return {
            fineAmount: 70,
          };
        case "21_TO_25":
          return {
            fineAmount: 115,
            licencePoints: 1,
          };
        case "26_TO_30":
          return {
            fineAmount: 180,
            licencePoints: 1,
            drivingBanPeriod: 0,
          };
        case "31_TO_40":
          return {
            fineAmount: 260,
            licencePoints: 2,
            drivingBanPeriod: 1,
          };
        case "41_TO_50":
          return {
            fineAmount: 400,
            licencePoints: 2,
            drivingBanPeriod: 1,
          };
        case "51_TO_60":
          return {
            fineAmount: 560,
            licencePoints: 2,
            drivingBanPeriod: 2,
          };
        case "61_TO_70":
        case "MORE_THAN_60":
          return {
            fineAmount: 700,
            licencePoints: 2,
            drivingBanPeriod: 3,
          };
        case "MORE_THAN_70":
          return {
            fineAmount: 800,
            licencePoints: 2,
            drivingBanPeriod: 3,
          };
        default:
      }
    }

    switch (data.TEMPO_TRAILER) {
      case "LESS_THAN_10":
        return {
          fineAmount: 20,
        };
      case "11_TO_15":
        return {
          fineAmount: 30,
        };
      case "16_TO_20":
        return {
          fineAmount: 80,
          licencePoints: 1,
        };
      case "21_TO_25":
        return {
          fineAmount: 95,
          licencePoints: 1,
        };
      case "26_TO_30":
        return {
          fineAmount: 140,
          licencePoints: 2,
          drivingBanPeriod: 1,
        };
      case "31_TO_40":
        return {
          fineAmount: 200,
          licencePoints: 2,
          drivingBanPeriod: 1,
        };
      case "41_TO_50":
        return {
          fineAmount: 280,
          licencePoints: 2,
          drivingBanPeriod: 2,
        };
      case "51_TO_60":
        return {
          fineAmount: 480,
          licencePoints: 2,
          drivingBanPeriod: 3,
        };
      case "61_TO_70":
        return {
          fineAmount: 680,
          licencePoints: 2,
          drivingBanPeriod: 3,
        };
      case "MORE_THAN_70":
        return {
          fineAmount: 680,
          licencePoints: 2,
          drivingBanPeriod: 3,
        };
      default:
    }
  }

  if (data.TYPE_OF_VEHICLE === "VEHICLE_ONLY") {
    switch (data.TEMPO) {
      case "LESS_THAN_10":
        return {
          fineAmount: 20,
        };
      case "11_TO_15":
        return {
          fineAmount: 40,
        };
      case "16_TO_20":
        return {
          fineAmount: 60,
        };
      case "21_TO_25":
        return {
          fineAmount: 100,
          licencePoints: 1,
        };
      case "26_TO_30":
        return {
          fineAmount: 150,
          licencePoints: 1,
          drivingBanPeriod: 0,
        };
      case "31_TO_40":
        return {
          fineAmount: 200,
          licencePoints: 1,
          drivingBanPeriod: 0,
        };
      case "41_TO_50":
        return {
          fineAmount: 320,
          licencePoints: 2,
          drivingBanPeriod: 1,
        };
      case "51_TO_60":
        return {
          fineAmount: 480,
          licencePoints: 2,
          drivingBanPeriod: 1,
        };
      case "61_TO_70":
        return {
          fineAmount: 600,
          licencePoints: 2,
          drivingBanPeriod: 2,
        };
      case "MORE_THAN_70":
        return {
          fineAmount: 700,
          licencePoints: 2,
          drivingBanPeriod: 3,
        };
      default:
    }
  }

  switch (data.TEMPO_TRAILER) {
    case "LESS_THAN_10":
      return {
        fineAmount: 15,
      };
    case "11_TO_15":
      return {
        fineAmount: 25,
      };
    case "16_TO_20":
      return {
        fineAmount: 70,
        licencePoints: 1,
      };
    case "21_TO_25":
      return {
        fineAmount: 80,
        licencePoints: 1,
      };
    case "26_TO_30":
      return {
        fineAmount: 95,
        licencePoints: 1,
      };
    case "31_TO_40":
      return {
        fineAmount: 160,
        licencePoints: 2,
        drivingBanPeriod: 1,
      };
    case "41_TO_50":
      return {
        fineAmount: 240,
        licencePoints: 2,
        drivingBanPeriod: 1,
      };
    case "51_TO_60":
      return {
        fineAmount: 440,
        licencePoints: 2,
        drivingBanPeriod: 2,
      };
    case "61_TO_70":
      return {
        fineAmount: 600,
        licencePoints: 2,
        drivingBanPeriod: 3,
      };
    case "MORE_THAN_70":
      return {
        fineAmount: 600,
        licencePoints: 2,
        drivingBanPeriod: 3,
      };
    default:
  }

  return {
    fineAmount: 0,
    licencePoints: 0,
    drivingBanPeriod: 0,
  };
};

export default calculate;
